import ServiceBase from './ServiceBase';

export default class AuthService extends ServiceBase {

    constructor() {
        super();
    }

    public GetBlocks(username:string): Promise<any> {
        
        return this.post('Docketing/GetDashboardBlocks', { UserName: username })
            .then((response) => { 
                return response;
            })
            .catch(error => {
                console.log('dashblocks erred');
            })
    }

    public GetBlockDetails(blockID: number, username: string): Promise<any> {

        return this.post('Docketing/GetDashboardBlockDetails', { UserName: username, DashboardBlockId: blockID })
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('dashblocks erred');
            })
    }
}



// WEBPACK FOOTER //
// ./ClientApp/src/services/DashboardService.ts